import { TranslationsContext } from '@teliaee/telia-translate';
import { Heading, List, ListItem, Separator, Tabs, TabsItem } from 'telia-front-react';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useStores } from '../../stores/RootStore';
import { getTranslationFallbackEt, hasTransportTexts } from './BranchUtil';

export const BranchTransportTexts = observer((): React.ReactElement => {
  const { branchStore, languageStore, onlineHelpEventStore, routeStore } = useStores();
  const { translate } = React.useContext(TranslationsContext);
  const branchState = branchStore.getBranchState(routeStore.decodedParams.branchId);

  const recordTransportTabChange = (tab: string) => {
    onlineHelpEventStore.recordEvent(`ACTION_SHOP_ACCESSIBILITY_PAGE_${tab}`);
  };
  const hasTexts = hasTransportTexts(branchState.branch, languageStore.currentLanguage);

  const getLocationLongDescItem = (): React.ReactElement => {
    return getTranslationFallbackEt(branchState.branch.locationDescriptionLong, languageStore.currentLanguage) ? (
      <ListItem icon={'#pin'} key={1} className="h5 text--pre-wrap">
        <span
          dangerouslySetInnerHTML={{
            __html: getTranslationFallbackEt(branchState.branch.locationDescriptionLong, languageStore.currentLanguage),
          }}
        />
      </ListItem>
    ) : null;
  };

  return (
    <>
      {!hasTexts && !!getTranslationFallbackEt(branchState.branch.locationDescriptionLong, languageStore.currentLanguage) && (
        <>
          <Separator spacing="xxsmall" color="invisible" />
          <List type="icon">{getLocationLongDescItem()}</List>
        </>
      )}
      {hasTexts && (
        <>
          <Heading id="directions-heading" element="h2" className="h3">
            {translate('branch.arrival.instructions')}
          </Heading>
          <Separator spacing="xxsmall" color="invisible" />
          <Tabs
            aria-labelledby="directions-heading"
            defaultCurrentTab="public-transport"
            onTabChange={(_prevTab: string, nextTab: string) => recordTransportTabChange(nextTab)}
            align="left"
            border={'top'}
          >
            <TabsItem id={'public-transport'} label={translate('branch.arrival.by.public')} key={'public-transport'}>
              <List type="icon">
                {!!getTranslationFallbackEt(branchState.branch.arrivalWithPublicTransport, languageStore.currentLanguage) && (
                  <ListItem icon={'#transfer'} key={0} className="h5 text--pre-wrap">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: getTranslationFallbackEt(branchState.branch.arrivalWithPublicTransport, languageStore.currentLanguage),
                      }}
                    />
                  </ListItem>
                )}
                {getLocationLongDescItem()}
              </List>
            </TabsItem>
            <TabsItem id={'car'} label={translate('branch.arrival.with.car')} key={'car'}>
              <List type="icon">
                {!!getTranslationFallbackEt(branchState.branch.arrivalWithCar, languageStore.currentLanguage) && (
                  <ListItem icon={'#car'} key={0} className="h5 text--pre-wrap">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: getTranslationFallbackEt(branchState.branch.arrivalWithCar, languageStore.currentLanguage),
                      }}
                    />
                  </ListItem>
                )}
                {getLocationLongDescItem()}
              </List>
            </TabsItem>
          </Tabs>
        </>
      )}
    </>
  );
});
